import { Component, OnInit } from '@angular/core';
import { GrievanceDashboardService } from '../grievance-dashboard.service';

@Component({
  selector: 'app-grievance-header',
  templateUrl: './grievance-header.component.html',
  styleUrls: ['./grievance-header.component.scss']
})
export class GrievanceHeaderComponent implements OnInit {
  isCollapsed: boolean = false;
  campusName: string | null;
  userName: string | null;

  constructor(private Service: GrievanceDashboardService) {
    this.Service.collapsed$.subscribe(data => {
      this.isCollapsed = data;
    });
  }
  ngOnInit(): void {
    this.campusName = localStorage.getItem('campusName');
    this.userName = localStorage.getItem('userName');

  }
  logOut() {
    const logoutPage = localStorage.getItem('logoutPage')
    if (logoutPage) {
      window.location.href = logoutPage;
    }
  }

  toggleCollapse() {
    this.Service.toggleCollapse();
    // const newWidth = this.isCollapsed ? '100%' : '92%';
    // this.Service.updateWidth(newWidth);
  }
}
